/* eslint-disable */
import Mock from 'mockjs'
import api from "../service/api"


Mock.mock(new RegExp(`.*${api.article_count}.*`), /.*/, () => {
    return {
        "code": 1,
        "errMsg": "ok",
        "data": {
            update: "2024-10-10 15:15:33",
            data: {
                total: 9,
                general: 3,
                notices: 3,
                events: 3,
                guides: 3,
                forum: 3
            }
        }
    }
})


Mock.mock(new RegExp(`.*${api.article_list}.*`), /.*/, () => {
    return {
        "code": 1,
        "errMsg": "ok",
        "data": [
            {
                title: "2024英雄联盟全球总决赛主题曲动画MV预热",
                html: "测试",
                date: "10-11"
            },
            {
                title: "2024英雄联盟全球总决赛主题曲动画MV预热",
                html: "测试",
                date: "10-11"
            },
            {
                title: "2024英雄联盟全球总决赛主题曲动画MV预热",
                html: "测试",
                date: "10-11"
            },
            {
                title: "2024英雄联盟全球总决赛主题曲动画MV预热",
                html: "测试",
                date: "10-11"
            },
            {
                title: "2024英雄联盟全球总决赛主题曲动画MV预热",
                html: "测试",
                date: "10-11"
            },
            {
                title: "2024英雄联盟全球总决赛主题曲动画MV预热",
                html: "测试",
                date: "10-11"
            },
            {
                title: "2024英雄联盟全球总决赛主题曲动画MV预热",
                html: "测试",
                date: "10-11"
            },
            {
                title: "2024英雄联盟全球总决赛主题曲动画MV预热",
                html: "测试",
                date: "10-11"
            },
            {
                title: "2024英雄联盟全球总决赛主题曲动画MV预热",
                html: "测试",
                date: "10-11"
            },
            {
                title: "2024英雄联盟全球总决赛主题曲动画MV预热",
                html: "测试",
                date: "10-11"
            }
        ]
    }
})
